import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js'

import { COGNITO_CLIENT_ID, COGNITO_POOL_ID } from '../utils/Constants'

const ResetPassword = () => {
  const location = useLocation()
  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const emailParam = params.get('email')
    if (emailParam) {
      setEmail(emailParam)
    }
  }, [location])

  const handleSubmit = async e => {
    e.preventDefault()
    setError(null)

    if (password !== confirmPassword) {
      setError('Passwords do not match')
      return
    }

    setLoading(true)

    const poolData = {
      UserPoolId: COGNITO_POOL_ID,
      ClientId: COGNITO_CLIENT_ID,
    }
    const userPool = new CognitoUserPool(poolData)
    const userData = {
      Username: email,
      Pool: userPool,
    }
    const cognitoUser = new CognitoUser(userData)

    cognitoUser.confirmPassword(code, password, {
      onSuccess: function () {
        setSuccess(true)
        setLoading(false)
        // Redirect to signin after a short delay or let user click
        setTimeout(() => {
          window.location.href = '/signin'
        }, 2000)
      },
      onFailure: function (err) {
        setError(err.message || 'Failed to reset password')
        setLoading(false)
      },
    })
  }

  if (success) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4">
            <div className="card shadow-sm">
              <div className="card-body p-4 text-center">
                <h3 className="mb-3 text-success">Success!</h3>
                <p>Your password has been reset successfully.</p>
                <p>Redirecting to Sign In...</p>
                <Link to="/signin" className="btn btn-primary mt-3">
                  Sign In Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow-sm">
            <div className="card-body p-4">
              <div className="text-center mb-4">
                <h3 className="mb-1">Reset Password</h3>
                <p className="text-muted">Enter the code sent to your email</p>
              </div>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <label htmlFor="email">Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    disabled={!!email} // Disable if pre-filled from URL
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="code">Verification Code</label>
                  <input
                    type="text"
                    className="form-control"
                    id="code"
                    placeholder="Enter code"
                    value={code}
                    onChange={e => setCode(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="password">New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder="New password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group mb-4">
                  <label htmlFor="confirmPassword">Confirm Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    placeholder="Confirm password"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-block w-100" disabled={loading}>
                  {loading ? 'Resetting...' : 'Reset Password'}
                </button>
              </form>

              <div className="text-center mt-3">
                <Link to="/signin">Back to Sign In</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResetPassword
